import { spaceQueryKeys } from "@/hooks/api/space/queryKeys";
import { useQuery } from "@tanstack/react-query";

import { api } from "@/api";
import { FieldType, ProjectType } from "@/types/space";

type SpaceResponse = {
  bannerUrl: string;
  category: ProjectType;
  fieldList: FieldType[];
  formId: number | null;
  formTag: string | null;
  id: number;
  introduction: string;
  memberCount: number;
  name: string;
  leader: {
    id: number;
    name: string;
  };
};

export const useApiGetSpace = (spaceId: number, isPublic: boolean = false, options?: { enabled?: boolean }) => {
  const getSpace = async (spaceId: number, isPublic: boolean) => {
    const endpoint = isPublic ? `/api/space/public/${spaceId}` : `/api/space/${spaceId}`;
    const res = await api.get<SpaceResponse>(endpoint);

    return res.data;
  };

  return useQuery({
    queryKey: spaceQueryKeys.detail(spaceId),
    queryFn: () => getSpace(spaceId, isPublic),
    enabled: options?.enabled ?? true,
  });
};
